// src/pages/PatientReminders.jsx
//import React, { useEffect, useMemo, useState } from "react";

// src/pages/PatientReminders.jsx
import RemindersLogic from "../components/RemindersLogic";

export default function PatientReminders({ patientId, multi = false, templateType = null }) {
  return (
        <RemindersLogic patientId={patientId} multi={multi} templateType={templateType} />
  );
}
